// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("image.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .map-card {
   width: 300px;
   border-radius: 8px;
   /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
   overflow: hidden;
   background: #fff;
   /* margin: auto; */
   font-size: 14px;
   position: relative;
   /* display: flex; */
 }

 .map-card:after {
   /* Arrow under the card */
   content: "";
   position: absolute;
   bottom: -10px;
   /* Adjust as necessary */
   left: 50%;
   transform: translateX(-50%);
   width: 0;
   height: 0;
   border-left: 10px solid transparent;
   border-right: 10px solid transparent;
   border-top: 10px solid red;
   /* Color of arrow */
 }

 .card-header {
   background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
   background-size: cover;
   background-position: center;
   height: 200px;
   /* Adjust height as needed */
   position: relative;
   color: white;
   padding: 10px 20px;
 }

 .card-header img {
   width: 100%;
   height: auto;
 }

 .card-header .close-btn {
   position: absolute;
   top: 10px;
   right: 10px;
   cursor: pointer;
   color: white;
   font-size: 20px;
 }

 .card-header .instructions-btn {
   position: absolute;
   top: 10px;
   left: 10px;
   background: red;
   color: white;
   padding: 3px 6px;
   font-size: 12px;
   border-radius: 4px;
   cursor: pointer;
 }

 .card-content {
   padding: 15px;
   color: #333;
 }

 .card-content p {
   margin: 5px 0;
 }

 .card-content p {
   margin: 5px 0;
   width: 100%;
 }

 .card-footer {
   background-color: #f8f8f8;
   color: #666;
   padding: 10px 15px;
   text-align: left;
 }

 .card-footer p {
   margin: 5px 0;
 }

 .infos-line,
 .infos-line a {
   display: flex;
   flex-direction: row;
   align-items: center;
   gap: 0.8rem;
   padding: 0;
 }

 .infos-line a {
   color: #c6183d;
   text-decoration: none;
 }

 #map {
   width: 100%;
   height: 100%;
   /* Adjust as needed */
   background-color: #e9e9e9;
   /* Placeholder color */
   margin-top: 20px;
   /* Space between card and map */
   position: relative;
 }

 /* Optional: Map instructions or overlay content */
 .map-instructions {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   /* background: rgba(255, 255, 255, 0.8); */
   text-align: center;
   padding: 10px;
   box-sizing: border-box;
 }

 .leaflet-popup-content {
   margin: 0 !important;
 }

 .titleofthemap {
   background-color: #c6183d;
   /* padding: 0.1rem 4rem 0.1rem 1rem; */
 }

 .titleofthemap p {
   color: #fff;
 }

 .map-container {
   margin: auto;
   display: flex;
   /* height: 500px; */
   width: 100vw;
   margin-top: 4rem;
 }

 .left {
   width: 20%;
   background-color: red;
   padding: 1rem;
 }

 .full-height-map {
   height: 100vh;
 }

 .right {
   width: 80%;
   background-color: blue;
 }
`, "",{"version":3,"sources":["webpack://./js/src/App.css"],"names":[],"mappings":"CAAC;GACE,YAAY;GACZ,kBAAkB;GAClB,+CAA+C;GAC/C,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,eAAe;GACf,kBAAkB;GAClB,mBAAmB;CACrB;;CAEA;GACE,yBAAyB;GACzB,WAAW;GACX,kBAAkB;GAClB,aAAa;GACb,wBAAwB;GACxB,SAAS;GACT,2BAA2B;GAC3B,QAAQ;GACR,SAAS;GACT,mCAAmC;GACnC,oCAAoC;GACpC,0BAA0B;GAC1B,mBAAmB;CACrB;;CAEA;GACE,yDAAkC;GAClC,sBAAsB;GACtB,2BAA2B;GAC3B,aAAa;GACb,4BAA4B;GAC5B,kBAAkB;GAClB,YAAY;GACZ,kBAAkB;CACpB;;CAEA;GACE,WAAW;GACX,YAAY;CACd;;CAEA;GACE,kBAAkB;GAClB,SAAS;GACT,WAAW;GACX,eAAe;GACf,YAAY;GACZ,eAAe;CACjB;;CAEA;GACE,kBAAkB;GAClB,SAAS;GACT,UAAU;GACV,eAAe;GACf,YAAY;GACZ,gBAAgB;GAChB,eAAe;GACf,kBAAkB;GAClB,eAAe;CACjB;;CAEA;GACE,aAAa;GACb,WAAW;CACb;;CAEA;GACE,aAAa;CACf;;CAEA;GACE,aAAa;GACb,WAAW;CACb;;CAEA;GACE,yBAAyB;GACzB,WAAW;GACX,kBAAkB;GAClB,gBAAgB;CAClB;;CAEA;GACE,aAAa;CACf;;CAEA;;GAEE,aAAa;GACb,mBAAmB;GACnB,mBAAmB;GACnB,WAAW;GACX,UAAU;CACZ;;CAEA;GACE,cAAc;GACd,qBAAqB;CACvB;;CAEA;GACE,WAAW;GACX,YAAY;GACZ,qBAAqB;GACrB,yBAAyB;GACzB,sBAAsB;GACtB,gBAAgB;GAChB,+BAA+B;GAC/B,kBAAkB;CACpB;;CAEA,kDAAkD;CAClD;GACE,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,WAAW;GACX,0CAA0C;GAC1C,kBAAkB;GAClB,aAAa;GACb,sBAAsB;CACxB;;CAEA;GACE,oBAAoB;CACtB;;CAEA;GACE,yBAAyB;GACzB,sCAAsC;CACxC;;CAEA;GACE,WAAW;CACb;;CAEA;GACE,YAAY;GACZ,aAAa;GACb,mBAAmB;GACnB,YAAY;GACZ,gBAAgB;CAClB;;CAEA;GACE,UAAU;GACV,qBAAqB;GACrB,aAAa;CACf;;CAEA;GACE,aAAa;CACf;;CAEA;GACE,UAAU;GACV,sBAAsB;CACxB","sourcesContent":[" .map-card {\n   width: 300px;\n   border-radius: 8px;\n   /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */\n   overflow: hidden;\n   background: #fff;\n   /* margin: auto; */\n   font-size: 14px;\n   position: relative;\n   /* display: flex; */\n }\n\n .map-card:after {\n   /* Arrow under the card */\n   content: \"\";\n   position: absolute;\n   bottom: -10px;\n   /* Adjust as necessary */\n   left: 50%;\n   transform: translateX(-50%);\n   width: 0;\n   height: 0;\n   border-left: 10px solid transparent;\n   border-right: 10px solid transparent;\n   border-top: 10px solid red;\n   /* Color of arrow */\n }\n\n .card-header {\n   background-image: url(\"image.jpg\");\n   background-size: cover;\n   background-position: center;\n   height: 200px;\n   /* Adjust height as needed */\n   position: relative;\n   color: white;\n   padding: 10px 20px;\n }\n\n .card-header img {\n   width: 100%;\n   height: auto;\n }\n\n .card-header .close-btn {\n   position: absolute;\n   top: 10px;\n   right: 10px;\n   cursor: pointer;\n   color: white;\n   font-size: 20px;\n }\n\n .card-header .instructions-btn {\n   position: absolute;\n   top: 10px;\n   left: 10px;\n   background: red;\n   color: white;\n   padding: 3px 6px;\n   font-size: 12px;\n   border-radius: 4px;\n   cursor: pointer;\n }\n\n .card-content {\n   padding: 15px;\n   color: #333;\n }\n\n .card-content p {\n   margin: 5px 0;\n }\n\n .card-content p {\n   margin: 5px 0;\n   width: 100%;\n }\n\n .card-footer {\n   background-color: #f8f8f8;\n   color: #666;\n   padding: 10px 15px;\n   text-align: left;\n }\n\n .card-footer p {\n   margin: 5px 0;\n }\n\n .infos-line,\n .infos-line a {\n   display: flex;\n   flex-direction: row;\n   align-items: center;\n   gap: 0.8rem;\n   padding: 0;\n }\n\n .infos-line a {\n   color: #c6183d;\n   text-decoration: none;\n }\n\n #map {\n   width: 100%;\n   height: 100%;\n   /* Adjust as needed */\n   background-color: #e9e9e9;\n   /* Placeholder color */\n   margin-top: 20px;\n   /* Space between card and map */\n   position: relative;\n }\n\n /* Optional: Map instructions or overlay content */\n .map-instructions {\n   position: absolute;\n   top: 0;\n   left: 0;\n   width: 100%;\n   /* background: rgba(255, 255, 255, 0.8); */\n   text-align: center;\n   padding: 10px;\n   box-sizing: border-box;\n }\n\n .leaflet-popup-content {\n   margin: 0 !important;\n }\n\n .titleofthemap {\n   background-color: #c6183d;\n   /* padding: 0.1rem 4rem 0.1rem 1rem; */\n }\n\n .titleofthemap p {\n   color: #fff;\n }\n\n .map-container {\n   margin: auto;\n   display: flex;\n   /* height: 500px; */\n   width: 100vw;\n   margin-top: 4rem;\n }\n\n .left {\n   width: 20%;\n   background-color: red;\n   padding: 1rem;\n }\n\n .full-height-map {\n   height: 100vh;\n }\n\n .right {\n   width: 80%;\n   background-color: blue;\n }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
